var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useGetAllMenuQuery } from "@/store/api";
import { useTranslation } from "react-i18next";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import queryString from "query-string";
import { faChevronDown, faChevronUp } from "@fortawesome/pro-solid-svg-icons";
import { useMemo, useState } from "react";
import { faSquare } from "@fortawesome/pro-regular-svg-icons";
import { IconMappingModule, iconsMapping } from "../iconCorrespondance";
import { Link } from "react-router-dom";
export default function Placeholder() {
    var _a;
    var menuResponse = useGetAllMenuQuery(null).data;
    // Memo : all modules used for translation
    var allModules = useMemo(function () {
        var _a, _b, _c, _d;
        var value = ((_d = (_c = (_b = (_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) === null || _b === void 0 ? void 0 : _b.tabs) === null || _c === void 0 ? void 0 : _c.LBL_TABGROUP_ALL) === null || _d === void 0 ? void 0 : _d.modules) || {};
        return Object.keys(value);
    }, [menuResponse]);
    var t = useTranslation("common").t;
    var _b = useState(null), openedMenu = _b[0], setOpenedMenu = _b[1];
    // eslint-disable-next-line react-hooks/exhaustive-deps
    var main = ((_a = menuResponse === null || menuResponse === void 0 ? void 0 : menuResponse.data) === null || _a === void 0 ? void 0 : _a.main) || [];
    var createMenu = useMemo(function () {
        var _a, _b, _c, _d;
        var list = main || {};
        var links = (list === null || list === void 0 ? void 0 : list.links) || {};
        var moduleLinks = {};
        var modules = (_b = (_a = list === null || list === void 0 ? void 0 : list.tabs) === null || _a === void 0 ? void 0 : _a.LBL_TABGROUP_ALL) === null || _b === void 0 ? void 0 : _b.modules;
        var _loop_1 = function (moduleKey) {
            var clientLinks = {};
            var linksUrls = (_c = links[moduleKey]) === null || _c === void 0 ? void 0 : _c.links;
            var image = (_d = links[moduleKey]) === null || _d === void 0 ? void 0 : _d.image;
            linksUrls.forEach(function (element) {
                var window = {};
                var location = window.location || {};
                var protocol = location.protocol || "http";
                var host = location.host || "localhost";
                var url = new URL(element.url, process.env.ETCRM_URL || "".concat(protocol, "://").concat(host));
                var query = url.search.split("?");
                var qs = query.length > 1 ? query[1] : query[0];
                var queryParts = queryString.parse(qs);
                var newLinkParts = [];
                var module = queryParts.module || "";
                var action = queryParts.action && queryParts.action !== "index"
                    ? queryParts.action
                    : "";
                delete queryParts.module;
                delete queryParts.action;
                for (var p in queryParts) {
                    newLinkParts.push("".concat(p, "=").concat(queryParts[p]));
                }
                var q = newLinkParts.length > 0 ? "?".concat(newLinkParts.join("&")) : "";
                clientLinks[element.id] = "".concat(module, "/").concat(action).concat(q);
            });
            moduleLinks[moduleKey] = {
                links: links[moduleKey],
                clientLinks: clientLinks,
                image: image,
            };
        };
        for (var moduleKey in modules) {
            _loop_1(moduleKey);
        }
        return moduleLinks;
    }, [main]);
    var filteredMenu = function () {
        var links = [];
        var menu = createMenu;
        for (var m in menu) {
            if (menu[m].links.links.length) {
                links[m] = menu[m];
            }
        }
        return links;
    };
    // show or not children's menu
    var toggleMenu = function (item) {
        if (openedMenu === item) {
            setOpenedMenu(null);
        }
        else {
            setOpenedMenu(item);
        }
    };
    var _c = useState(null), hoveredItem = _c[0], setHoveredItem = _c[1];
    var menuAll = Object.values(filteredMenu());
    return (_jsx("div", __assign({ className: "h-full px-3 py-4 overflow-hidden" }, { children: _jsx("div", __assign({ className: "space-y-2" }, { children: menuAll === null || menuAll === void 0 ? void 0 : menuAll.map(function (item, key) {
                var _a, _b, _c, _d, _e, _f, _g, _h, _j;
                var hasSubMenu = ((_a = item === null || item === void 0 ? void 0 : item.links) === null || _a === void 0 ? void 0 : _a.links) && item.links.links.length > 0;
                return (_jsxs("div", __assign({ className: "menu-contain ".concat(openedMenu === ((_b = item === null || item === void 0 ? void 0 : item.links) === null || _b === void 0 ? void 0 : _b.label) ? "open" : "") }, { children: [_jsxs("p", __assign({ className: "menu-contain__label flex uppercase cursor-pointer text-justify p-1 relative hover:bg-[#eef1f7] hover:rounded\n                ", onMouseEnter: function () { return setHoveredItem(item === null || item === void 0 ? void 0 : item.links.label); }, onMouseLeave: function () { return setHoveredItem(null); }, onClick: function () { var _a; return toggleMenu((_a = item === null || item === void 0 ? void 0 : item.links) === null || _a === void 0 ? void 0 : _a.label); } }, { children: [_jsx("span", __assign({ className: "flex items-center justify-center w-6 h-6 mr-2 pl-2" }, { children: _jsx(FontAwesomeIcon, { icon: IconMappingModule["".concat((_c = item === null || item === void 0 ? void 0 : item.links) === null || _c === void 0 ? void 0 : _c.module)]
                                            ? IconMappingModule["".concat((_d = item === null || item === void 0 ? void 0 : item.links) === null || _d === void 0 ? void 0 : _d.module)]
                                            : faSquare, className: "mr-4" }) })), _jsx("span", { children: (_g = (_f = (_e = item === null || item === void 0 ? void 0 : item.links) === null || _e === void 0 ? void 0 : _e.mod_strings) === null || _f === void 0 ? void 0 : _f.LBL_MODULE_NAME) !== null && _g !== void 0 ? _g : t(item === null || item === void 0 ? void 0 : item.links.label) }), (openedMenu === (item === null || item === void 0 ? void 0 : item.links.label) ||
                                    (hoveredItem === (item === null || item === void 0 ? void 0 : item.links.label) && hasSubMenu)) && (_jsx(FontAwesomeIcon, { icon: openedMenu === (item === null || item === void 0 ? void 0 : item.links.label)
                                        ? faChevronUp
                                        : faChevronDown, className: "absolute right-0 top-2 mr-4" }))] })), _jsx("ul", __assign({ className: "".concat(openedMenu === ((_h = item === null || item === void 0 ? void 0 : item.links) === null || _h === void 0 ? void 0 : _h.label)
                                ? "menu-contain__list block"
                                : "menu-contain__list hidden", " ml-4") }, { children: (_j = item === null || item === void 0 ? void 0 : item.links) === null || _j === void 0 ? void 0 : _j.links.map(function (i, key) {
                                var _a, _b, _c;
                                return (_jsx("li", __assign({ className: "hover:bg-[#eef1f7]  px-2 py-1 text-md hover:rounded" }, { children: _jsxs(Link, __assign({ to: "/modules/".concat(item.clientLinks[i.id]), title: i.label }, { children: [_jsx(FontAwesomeIcon, { icon: iconsMapping["".concat(i.image)]
                                                    ? iconsMapping["".concat(i.image)]
                                                    : faSquare, className: "mr-2 text-sm" }), _jsx("span", { children: ((_a = item === null || item === void 0 ? void 0 : item.links) === null || _a === void 0 ? void 0 : _a.mod_strings) !== null &&
                                                    ((_b = item === null || item === void 0 ? void 0 : item.links) === null || _b === void 0 ? void 0 : _b.mod_strings[i.label])
                                                    ? (_c = item === null || item === void 0 ? void 0 : item.links) === null || _c === void 0 ? void 0 : _c.mod_strings[i.label]
                                                    : i.label })] })) }), key));
                            }) }))] }), key));
            }) })) })));
}
